export default "__VITE_ASSET__CE0GcTj4__"